<template>
    <div>
        <Table :isEmpty="!pendingJobs.length">
            <TableHead>
                <TableHeadCell>ID</TableHeadCell>
                <TableHeadCell>Key</TableHeadCell>
                <TableHeadCell>Queue name</TableHeadCell>
                <TableHeadCell>Releases</TableHeadCell>
                <TableHeadCell>Retries</TableHeadCell>
                <TableHeadCell>Execute after</TableHeadCell>
            </TableHead>
            <TableBody>
                <PendingJobTableRow
                    v-for="(job, index) in pendingJobs"
                    :key="index"
                    :job="job"
                />
            </TableBody>

            <template #emptyState>
                <TableEmptyState title="No jobs found." />
            </template>
        </Table>
    </div>
</template>

<script setup lang="ts">
    import type { PropType } from 'vue'
    import Table from '@/Shared/Component/Table/Table.vue'
    import TableHead from '@/Shared/Component/Table/TableHead.vue'
    import TableHeadCell from '@/Shared/Component/Table/TableHeadCell.vue'
    import TableBody from '@/Shared/Component/Table/TableBody.vue'
    import TableEmptyState from '@/Shared/Component/Table/TableEmptyState.vue'
    import PendingJobTableRow from '@/Admin/Queue/Component/PendingJobTableRow.vue'
    import type { PendingQueueJobData } from '@/Shared/AutoGenerated/Main'

    const props = defineProps({
        pendingJobs: {
            type: Array as PropType<PendingQueueJobData[]>,
            required: true,
        },
    })
</script>
